import { render, staticRenderFns } from "./scrollNum.vue?vue&type=template&id=00a2fbf0&"
import script from "./scrollNum.vue?vue&type=script&lang=js&"
export * from "./scrollNum.vue?vue&type=script&lang=js&"
import style0 from "./scrollNum.vue?vue&type=style&index=0&id=00a2fbf0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports